var map = {
	"../about/about.module": [
		"./src/app/pages/about/about.module.ts",
		"default~about-about-module~pages-tabs-page-tabs-page-module",
		"common"
	],
	"../bg20-policy-details-transaction-history/bg20-policy-details-transaction-history.module": [
		"./src/app/pages/bg20-policy-details-transaction-history/bg20-policy-details-transaction-history.module.ts",
		"bg20-policy-details-transaction-history-bg20-policy-details-transaction-history-module"
	],
	"../f03-policy-information/f03-policy-information.module": [
		"./src/app/pages/f03-policy-information/f03-policy-information.module.ts",
		"f03-policy-information-f03-policy-information-module"
	],
	"../f04-policy-transaction/f04-policy-transaction.module": [
		"./src/app/pages/f04-policy-transaction/f04-policy-transaction.module.ts",
		"f04-policy-transaction-f04-policy-transaction-module"
	],
	"./components/complex-table/complex-table-row-detail/complex-table-row-detail.module": [
		"./src/app/components/complex-table/complex-table-row-detail/complex-table-row-detail.module.ts",
		"components-complex-table-complex-table-row-detail-complex-table-row-detail-module"
	],
	"./pages/a01-login-page/a01-login-page.module": [
		"./src/app/pages/a01-login-page/a01-login-page.module.ts",
		"pages-a01-login-page-a01-login-page-module"
	],
	"./pages/b01-signup-identity-verification/b01-signup-identity-verification.module": [
		"./src/app/pages/b01-signup-identity-verification/b01-signup-identity-verification.module.ts",
		"pages-b01-signup-identity-verification-b01-signup-identity-verification-module"
	],
	"./pages/b02-signup-online-user-identity/b02-signup-online-user-identity.module": [
		"./src/app/pages/b02-signup-online-user-identity/b02-signup-online-user-identity.module.ts",
		"pages-b02-signup-online-user-identity-b02-signup-online-user-identity-module"
	],
	"./pages/bg01-advance-search-page/bg01-advance-search-page.module": [
		"./src/app/pages/bg01-advance-search-page/bg01-advance-search-page.module.ts",
		"pages-bg01-advance-search-page-bg01-advance-search-page-module"
	],
	"./pages/bg01-policy/bg01-policy.module": [
		"./src/app/pages/bg01-policy/bg01-policy.module.ts",
		"pages-bg01-policy-bg01-policy-module"
	],
	"./pages/bg02-05-advance-search-page/bg02-05-advance-search-page.module": [
		"./src/app/pages/bg02-05-advance-search-page/bg02-05-advance-search-page.module.ts",
		"pages-bg02-05-advance-search-page-bg02-05-advance-search-page-module"
	],
	"./pages/bg02-05-policy-list/bg02-05-policy-list.module": [
		"./src/app/pages/bg02-05-policy-list/bg02-05-policy-list.module.ts",
		"pages-bg02-05-policy-list-bg02-05-policy-list-module"
	],
	"./pages/bg03a-pending-policy-details/bg03a-pending-policy-details.module": [
		"./src/app/pages/bg03a-pending-policy-details/bg03a-pending-policy-details.module.ts",
		"pages-bg03a-pending-policy-details-bg03a-pending-policy-details-module"
	],
	"./pages/bg06-document-download/bg06-document-download.module": [
		"./src/app/pages/bg06-document-download/bg06-document-download.module.ts",
		"pages-bg06-document-download-bg06-document-download-module"
	],
	"./pages/bg07-birthday-list/bg07-birthday-list.module": [
		"./src/app/pages/bg07-birthday-list/bg07-birthday-list.module.ts",
		"pages-bg07-birthday-list-bg07-birthday-list-module"
	],
	"./pages/bg08-switching-select-policy-and-account/bg08-switching-select-policy-and-account.module": [
		"./src/app/pages/bg08-switching-select-policy-and-account/bg08-switching-select-policy-and-account.module.ts",
		"pages-bg08-switching-select-policy-and-account-bg08-switching-select-policy-and-account-module"
	],
	"./pages/bg12-redirection-select-policy-and-account/bg12-redirection-select-policy-and-account.module": [
		"./src/app/pages/bg12-redirection-select-policy-and-account/bg12-redirection-select-policy-and-account.module.ts",
		"pages-bg12-redirection-select-policy-and-account-bg12-redirection-select-policy-and-account-module"
	],
	"./pages/bg16-advance-search-page/bg16-advance-search-page.module": [
		"./src/app/pages/bg16-advance-search-page/bg16-advance-search-page.module.ts",
		"pages-bg16-advance-search-page-bg16-advance-search-page-module"
	],
	"./pages/bg16-policy-transaction-log/bg16-policy-transaction-log.module": [
		"./src/app/pages/bg16-policy-transaction-log/bg16-policy-transaction-log.module.ts",
		"pages-bg16-policy-transaction-log-bg16-policy-transaction-log-module"
	],
	"./pages/bg16a-policy-transaction-log-detail/bg16a-policy-transaction-log-detail.module": [
		"./src/app/pages/bg16a-policy-transaction-log-detail/bg16a-policy-transaction-log-detail.module.ts",
		"pages-bg16a-policy-transaction-log-detail-bg16a-policy-transaction-log-detail-module"
	],
	"./pages/bg20-policy-details-transaction-history/bg20-policy-details-transaction-history.module": [
		"./src/app/pages/bg20-policy-details-transaction-history/bg20-policy-details-transaction-history.module.ts",
		"bg20-policy-details-transaction-history-bg20-policy-details-transaction-history-module"
	],
	"./pages/bh02-sales-reports-commission/bh02-sales-reports-commission.module": [
		"./src/app/pages/bh02-sales-reports-commission/bh02-sales-reports-commission.module.ts",
		"pages-bh02-sales-reports-commission-bh02-sales-reports-commission-module"
	],
	"./pages/bh03-sales-reports-policy-report-download/bh03-sales-reports-policy-report-download.module": [
		"./src/app/pages/bh03-sales-reports-policy-report-download/bh03-sales-reports-policy-report-download.module.ts",
		"pages-bh03-sales-reports-policy-report-download-bh03-sales-reports-policy-report-download-module"
	],
	"./pages/bh04-sales-reports-investment-statement-download/bh04-sales-reports-investment-statement-download.module": [
		"./src/app/pages/bh04-sales-reports-investment-statement-download/bh04-sales-reports-investment-statement-download.module.ts",
		"pages-bh04-sales-reports-investment-statement-download-bh04-sales-reports-investment-statement-download-module"
	],
	"./pages/bh05-sales-reports-document-download/bh05-sales-reports-document-download.module": [
		"./src/app/pages/bh05-sales-reports-document-download/bh05-sales-reports-document-download.module.ts",
		"pages-bh05-sales-reports-document-download-bh05-sales-reports-document-download-module"
	],
	"./pages/bi01-products/bi01-products.module": [
		"./src/app/pages/bi01-products/bi01-products.module.ts",
		"pages-bi01-products-bi01-products-module"
	],
	"./pages/bi02-product-heritage/bi02-product-heritage.module": [
		"./src/app/pages/bi02-product-heritage/bi02-product-heritage.module.ts",
		"pages-bi02-product-heritage-bi02-product-heritage-module"
	],
	"./pages/bj01-investment-choice/bj01-investment-choice.module": [
		"./src/app/pages/bj01-investment-choice/bj01-investment-choice.module.ts",
		"pages-bj01-investment-choice-bj01-investment-choice-module"
	],
	"./pages/bj02-our-investment-choices/bj02-our-investment-choices.module": [
		"./src/app/pages/bj02-our-investment-choices/bj02-our-investment-choices.module.ts",
		"pages-bj02-our-investment-choices-bj02-our-investment-choices-module"
	],
	"./pages/bk01-tools/bk01-tools.module": [
		"./src/app/pages/bk01-tools/bk01-tools.module.ts",
		"pages-bk01-tools-bk01-tools-module"
	],
	"./pages/bk02-market-commentary/bk02-market-commentary.module": [
		"./src/app/pages/bk02-market-commentary/bk02-market-commentary.module.ts",
		"pages-bk02-market-commentary-bk02-market-commentary-module"
	],
	"./pages/bk03-education-series/bk03-education-series.module": [
		"./src/app/pages/bk03-education-series/bk03-education-series.module.ts",
		"pages-bk03-education-series-bk03-education-series-module"
	],
	"./pages/bk05-investment-choices-comparison/bk05-investment-choices-comparison.module": [
		"./src/app/pages/bk05-investment-choices-comparison/bk05-investment-choices-comparison.module.ts",
		"pages-bk05-investment-choices-comparison-bk05-investment-choices-comparison-module"
	],
	"./pages/bk07-market-performance-snapshot/bk07-market-performance-snapshot.module": [
		"./src/app/pages/bk07-market-performance-snapshot/bk07-market-performance-snapshot.module.ts",
		"pages-bk07-market-performance-snapshot-bk07-market-performance-snapshot-module"
	],
	"./pages/bl01-service-center/bl01-service-center.module": [
		"./src/app/pages/bl01-service-center/bl01-service-center.module.ts",
		"pages-bl01-service-center-bl01-service-center-module"
	],
	"./pages/bl02-service-center-application/bl02-service-center-application.module": [
		"./src/app/pages/bl02-service-center-application/bl02-service-center-application.module.ts",
		"pages-bl02-service-center-application-bl02-service-center-application-module"
	],
	"./pages/bl03-service-center-management/bl03-service-center-management.module": [
		"./src/app/pages/bl03-service-center-management/bl03-service-center-management.module.ts",
		"pages-bl03-service-center-management-bl03-service-center-management-module"
	],
	"./pages/bl04-service-center-guidelines/bl04-service-center-guidelines.module": [
		"./src/app/pages/bl04-service-center-guidelines/bl04-service-center-guidelines.module.ts",
		"pages-bl04-service-center-guidelines-bl04-service-center-guidelines-module"
	],
	"./pages/bl05-service-center-provision/bl05-service-center-provision.module": [
		"./src/app/pages/bl05-service-center-provision/bl05-service-center-provision.module.ts",
		"pages-bl05-service-center-provision-bl05-service-center-provision-module"
	],
	"./pages/bl06-service-center-disable/bl06-service-center-disable.module": [
		"./src/app/pages/bl06-service-center-disable/bl06-service-center-disable.module.ts",
		"pages-bl06-service-center-disable-bl06-service-center-disable-module"
	],
	"./pages/bl07-service-center-investment/bl07-service-center-investment.module": [
		"./src/app/pages/bl07-service-center-investment/bl07-service-center-investment.module.ts",
		"pages-bl07-service-center-investment-bl07-service-center-investment-module"
	],
	"./pages/bm01-broker-communication/bm01-broker-communication.module": [
		"./src/app/pages/bm01-broker-communication/bm01-broker-communication.module.ts",
		"pages-bm01-broker-communication-bm01-broker-communication-module"
	],
	"./pages/bn01-important-information-before-investment/bn01-important-information-before-investment.module": [
		"./src/app/pages/bn01-important-information-before-investment/bn01-important-information-before-investment.module.ts",
		"pages-bn01-important-information-before-investment-bn01-important-information-before-investment-module"
	],
	"./pages/c01-forgot-password/c01-forgot-password.module": [
		"./src/app/pages/c01-forgot-password/c01-forgot-password.module.ts",
		"pages-c01-forgot-password-c01-forgot-password-module"
	],
	"./pages/d01-forgot-userid/d01-forgot-userid.module": [
		"./src/app/pages/d01-forgot-userid/d01-forgot-userid.module.ts",
		"pages-d01-forgot-userid-d01-forgot-userid-module"
	],
	"./pages/f01-j01-wealth-protection/f01-j01-wealth-protection.module": [
		"./src/app/pages/f01-j01-wealth-protection/f01-j01-wealth-protection.module.ts",
		"pages-f01-j01-wealth-protection-f01-j01-wealth-protection-module"
	],
	"./pages/f01-my-wealth/f01-my-wealth.module": [
		"./src/app/pages/f01-my-wealth/f01-my-wealth.module.ts",
		"pages-f01-my-wealth-f01-my-wealth-module"
	],
	"./pages/f02-financial-summary/f02-financial-summary.module": [
		"./src/app/pages/f02-financial-summary/f02-financial-summary.module.ts",
		"default~pages-f02-financial-summary-f02-financial-summary-module~pages-tabs-page-tabs-page-module",
		"common"
	],
	"./pages/f03-policy-information/f03-policy-information.module": [
		"./src/app/pages/f03-policy-information/f03-policy-information.module.ts",
		"f03-policy-information-f03-policy-information-module"
	],
	"./pages/f04-policy-transaction/f04-policy-transaction.module": [
		"./src/app/pages/f04-policy-transaction/f04-policy-transaction.module.ts",
		"f04-policy-transaction-f04-policy-transaction-module"
	],
	"./pages/f04a-policy-transaction-detail/f04a-policy-transaction-detail.module": [
		"./src/app/pages/f04a-policy-transaction-detail/f04a-policy-transaction-detail.module.ts",
		"pages-f04a-policy-transaction-detail-f04a-policy-transaction-detail-module"
	],
	"./pages/fund-detail/fund-detail.module": [
		"./src/app/pages/fund-detail/fund-detail.module.ts",
		"pages-fund-detail-fund-detail-module"
	],
	"./pages/g01-switching/g01-switching.module": [
		"./src/app/pages/g01-switching/g01-switching.module.ts",
		"pages-g01-switching-g01-switching-module"
	],
	"./pages/g01a-switch-out-detail/g01a-switch-out-detail.module": [
		"./src/app/pages/g01a-switch-out-detail/g01a-switch-out-detail.module.ts",
		"pages-g01a-switch-out-detail-g01a-switch-out-detail-module"
	],
	"./pages/g01b-switch-in-detail/g01b-switch-in-detail.module": [
		"./src/app/pages/g01b-switch-in-detail/g01b-switch-in-detail.module.ts",
		"pages-g01b-switch-in-detail-g01b-switch-in-detail-module"
	],
	"./pages/g02-switching-data-confirmation/g02-switching-data-confirmation.module": [
		"./src/app/pages/g02-switching-data-confirmation/g02-switching-data-confirmation.module.ts",
		"pages-g02-switching-data-confirmation-g02-switching-data-confirmation-module"
	],
	"./pages/g03-switching-completed/g03-switching-completed.module": [
		"./src/app/pages/g03-switching-completed/g03-switching-completed.module.ts",
		"pages-g03-switching-completed-g03-switching-completed-module"
	],
	"./pages/g04-risk-warning/g04-risk-warning.module": [
		"./src/app/pages/g04-risk-warning/g04-risk-warning.module.ts",
		"pages-g04-risk-warning-g04-risk-warning-module"
	],
	"./pages/h01-redirection/h01-redirection.module": [
		"./src/app/pages/h01-redirection/h01-redirection.module.ts",
		"pages-h01-redirection-h01-redirection-module"
	],
	"./pages/h01a-future-investment-detail/h01a-future-investment-detail.module": [
		"./src/app/pages/h01a-future-investment-detail/h01a-future-investment-detail.module.ts",
		"pages-h01a-future-investment-detail-h01a-future-investment-detail-module"
	],
	"./pages/h02-redirection-data-confirmation/h02-redirection-data-confirmation.module": [
		"./src/app/pages/h02-redirection-data-confirmation/h02-redirection-data-confirmation.module.ts",
		"pages-h02-redirection-data-confirmation-h02-redirection-data-confirmation-module"
	],
	"./pages/h03-redirection-completed/h03-redirection-completed.module": [
		"./src/app/pages/h03-redirection-completed/h03-redirection-completed.module.ts",
		"pages-h03-redirection-completed-h03-redirection-completed-module"
	],
	"./pages/i01-my-documents/i01-my-documents.module": [
		"./src/app/pages/i01-my-documents/i01-my-documents.module.ts",
		"pages-i01-my-documents-i01-my-documents-module"
	],
	"./pages/ib01-movies-list/ib01-movies-list.module": [
		"./src/app/pages/ib01-movies-list/ib01-movies-list.module.ts",
		"pages-ib01-movies-list-ib01-movies-list-module"
	],
	"./pages/ib02-movie-detail/ib02-movie-detail.module": [
		"./src/app/pages/ib02-movie-detail/ib02-movie-detail.module.ts",
		"pages-ib02-movie-detail-ib02-movie-detail-module"
	],
	"./pages/j01-my-protection/j01-my-protection.module": [
		"./src/app/pages/j01-my-protection/j01-my-protection.module.ts",
		"pages-j01-my-protection-j01-my-protection-module"
	],
	"./pages/j02-protection-financial-summary/j02-protection-financial-summary.module": [
		"./src/app/pages/j02-protection-financial-summary/j02-protection-financial-summary.module.ts",
		"pages-j02-protection-financial-summary-j02-protection-financial-summary-module"
	],
	"./pages/j03-protection-policy-information/j03-protection-policy-information.module": [
		"./src/app/pages/j03-protection-policy-information/j03-protection-policy-information.module.ts",
		"pages-j03-protection-policy-information-j03-protection-policy-information-module"
	],
	"./pages/k02-personal-information/k02-personal-information.module": [
		"./src/app/pages/k02-personal-information/k02-personal-information.module.ts",
		"pages-k02-personal-information-k02-personal-information-module"
	],
	"./pages/k03-change-personal-information/k03-change-personal-information.module": [
		"./src/app/pages/k03-change-personal-information/k03-change-personal-information.module.ts",
		"pages-k03-change-personal-information-k03-change-personal-information-module"
	],
	"./pages/k04-change-password/k04-change-password.module": [
		"./src/app/pages/k04-change-password/k04-change-password.module.ts",
		"common",
		"pages-k04-change-password-k04-change-password-module"
	],
	"./pages/l02-service-centre/l02-service-centre.module": [
		"./src/app/pages/l02-service-centre/l02-service-centre.module.ts",
		"pages-l02-service-centre-l02-service-centre-module"
	],
	"./pages/l03-service-forms/l03-service-forms.module": [
		"./src/app/pages/l03-service-forms/l03-service-forms.module.ts",
		"pages-l03-service-forms-l03-service-forms-module"
	],
	"./pages/l04-payment-methods/l04-payment-methods.module": [
		"./src/app/pages/l04-payment-methods/l04-payment-methods.module.ts",
		"pages-l04-payment-methods-l04-payment-methods-module"
	],
	"./pages/m02-notice-investment-choice/m02-notice-investment-choice.module": [
		"./src/app/pages/m02-notice-investment-choice/m02-notice-investment-choice.module.ts",
		"pages-m02-notice-investment-choice-m02-notice-investment-choice-module"
	],
	"./pages/m03-notice-latest-news/m03-notice-latest-news.module": [
		"./src/app/pages/m03-notice-latest-news/m03-notice-latest-news.module.ts",
		"pages-m03-notice-latest-news-m03-notice-latest-news-module"
	],
	"./pages/n02-contact-us/n02-contact-us.module": [
		"./src/app/pages/n02-contact-us/n02-contact-us.module.ts",
		"pages-n02-contact-us-n02-contact-us-module"
	],
	"./pages/n03-legal-and-privacy-statement/n03-legal-and-privacy-statement.module": [
		"./src/app/pages/n03-legal-and-privacy-statement/n03-legal-and-privacy-statement.module.ts",
		"pages-n03-legal-and-privacy-statement-n03-legal-and-privacy-statement-module"
	],
	"./pages/n04-site-map/n04-site-map.module": [
		"./src/app/pages/n04-site-map/n04-site-map.module.ts",
		"pages-n04-site-map-n04-site-map-module"
	],
	"./pages/n05-inplus-promotion/n05-inplus-promotion.module": [
		"./src/app/pages/n05-inplus-promotion/n05-inplus-promotion.module.ts",
		"pages-n05-inplus-promotion-n05-inplus-promotion-module"
	],
	"./pages/r01-top5-inflow-outflow/r01-top5-inflow-outflow.module": [
		"./src/app/pages/r01-top5-inflow-outflow/r01-top5-inflow-outflow.module.ts",
		"pages-r01-top5-inflow-outflow-r01-top5-inflow-outflow-module"
	],
	"./pages/tabs-page/tabs-page.module": [
		"./src/app/pages/tabs-page/tabs-page.module.ts",
		"default~pages-f02-financial-summary-f02-financial-summary-module~pages-tabs-page-tabs-page-module",
		"default~about-about-module~pages-tabs-page-tabs-page-module",
		"common",
		"pages-tabs-page-tabs-page-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;